import {formsStore} from '../../../../stores/Form';
import {createTemporarilyRecord} from '../../../../stores/Form/utils';
import {RecordEditState, UpdateActions} from '../../../../stores/Form/enums';
import {prefetchSubformData} from '../../actions/form';

export const openNewEmptyRecord = async () => {
    const {currentScreen} = formsStore;
    const form = currentScreen?.getActiveForm?.();

    if (!form) return;

    createTemporarilyRecord(form);
    if (form.currentRecord.isNew) {
        form.setSubForm(null);
    }

    //Open Popup only for main form
    if (form.level === 0) {
        currentScreen.setRecordDialog(true);
    }
};

export const openRecordInFocusView = async () => {
    const {currentScreen} = formsStore;
    const form = currentScreen?.getActiveForm?.();

    if (!form) return;

    if (form.currentRecord.keys?.length > 0 && !form.isApiLock()) {
        const activeSubForm = form.activeSubForm;
        if (
            (activeSubForm && activeSubForm?.isEmpty) ||
            (!activeSubForm && form.subFormsList.length > 0)
        ) {
            await prefetchSubformData(form, form.currentRecord?.recordIndex);
        }
    }

    currentScreen.setRecordDialog(true);
};

export const hideEmptyRecord = async () => {
    const {currentScreen} = formsStore;

    if (!currentScreen) return;

    const currentForm = currentScreen.getActiveForm();

    if (currentScreen.editMode !== RecordEditState.default) {
        const isValid = await currentScreen.checkAndSave(UpdateActions.update_save);
        if (!isValid) return;
    }

    if (currentForm) {
        if (currentForm?.records[currentForm.currentRow]?.isTemporary) {
            //remove empty temporarily records from the screen
            currentScreen.removeRecordFromClient(currentForm.currentRow);
        }
        currentForm.setCurrentColumnIdByIndex(0);
    }

    currentScreen.setRecordDialog(false);
};
